<template>
  <TracksAdmin />
</template>

<script>
import TracksAdmin from '../components/TracksAdmin'

export default {
  components: {
    TracksAdmin
  }
}
</script>
